import React from 'react';
import { useParams } from 'react-router-dom';
import WizardForm from '../components/WizardForm';

export default function FormularioPage() {
  const { id } = useParams<{ id: string }>();
  const existingId = id ? Number(id) : undefined;

  return <WizardForm existingId={existingId} />;
}
